<h1 mat-dialog-title>
  <mat-icon class="title-icon" [class.unexpected]="data.unexpected">{{data.unexpected ? 'error' : 'info'}}</mat-icon>
  {{title}}
</h1>
<mat-dialog-content>
  <p class="message">{{data.message}}</p>

  @if (moreErrors > 0) {
    <p class="more">{{moreErrors}} more {{moreErrors === 1 ? 'error' : 'errors'}} happened while this was open.</p>
  }
  @if (data.canReload) {
    <p class="note">Reloading the page loses any changes you haven't saved.</p>
  }

  @if (data.details) {
    <button mat-button class="details-toggle" (click)="showDetails = !showDetails" [attr.aria-expanded]="showDetails">
      <mat-icon>{{showDetails ? 'expand_less' : 'expand_more'}}</mat-icon>
      Technical details
    </button>
    @if (showDetails) {
      <pre class="details">{{data.details}}</pre>
    }
  }
</mat-dialog-content>
<mat-dialog-actions>
  @if (data.details) {
    <button mat-button (click)="copyDetails()">
      <mat-icon>{{copied ? 'check' : 'content_copy'}}</mat-icon>
      {{copied ? 'Copied' : 'Copy details'}}
    </button>
  }
  <span class="spacer"></span>
  @if (data.canReload) {
    <button mat-button (click)="reload()">Reload page</button>
  }
  <button mat-flat-button color="accent" mat-dialog-close cdkFocusInitial>Close</button>
</mat-dialog-actions>
